import Button from "@amzn/meridian/esm/components/button";
import Icon from "@amzn/meridian/esm/components/icon";
import Row from "@amzn/meridian/esm/components/row";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import thumbsUpTokens from "@amzn/meridian-tokens/base/icon/thumbs-up";
import thumbsDownTokens from "@amzn/meridian-tokens/base/icon/thumbs-down";
import { FEEDBACK } from "../../constants";
import { BUTTON_HEIGHT_SMALL, BUTTON_MIN_WIDTH } from "./feedback.constants";
import { THEME_COLOR } from "../../styles/colors";
import { scaleIconClass } from "../../styles/icon.styles";

const FeedbackButton = ({ feedbackType, disabled, onThumbsClick, label, tokenType }) => {
  return (
    <Button
        type={feedbackType}
        size="small"
        minWidth={BUTTON_MIN_WIDTH}
        disabled={disabled}
        onClick={onThumbsClick}
        aria-label={label}
    >
      <Icon className={scaleIconClass(0.673)} tokens={tokenType} />
    </Button>
  )
}

const FeedbackButtons = ({ feedback, disabled, onThumbsUp, onThumbsDown }) => (
  <Row alignmentHorizontal="end" spacing="none">
    <Theme tokens={{
      buttonHeightSmall: BUTTON_HEIGHT_SMALL,
      buttonBackgroundColorIconHover: THEME_COLOR.LIGHT_TEAL,
      buttonForegroundColorIconDefault: THEME_COLOR.MID_GRAY,
      buttonForegroundColorIconHover: THEME_COLOR.MOSS_GREEN,
      buttonBackgroundColorPrimaryDisabled: "transparent",
      buttonForegroundColorPrimaryDisabled: THEME_COLOR.MOSS_GREEN,
    }}>
      <FeedbackButton
        feedbackType={feedback === FEEDBACK.THUMBS_UP ? "primary" : "icon"}
        disabled={disabled}
        onThumbsClick={onThumbsUp}
        label="Thumbs up"
        tokenType={thumbsUpTokens}
      />
      <FeedbackButton
        feedbackType={feedback === FEEDBACK.THUMBS_DOWN ? "primary" : "icon"}
        disabled={disabled}
        onThumbsClick={onThumbsDown}
        label="Thumbs down"
        tokenType={thumbsDownTokens}
      />
    </Theme>
  </Row>
);

export default FeedbackButtons;
